module.exports = __webpack_public_path__ + "img/workflowspecialist.d4e79be1.png";